import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import NotificationsContainer from '@components/Common/Notifications';
import { useAuth } from '@components/MsalProvider';
import { UILanguage } from '~types/types';
import Languages from './Languages';
import LoginBox from './LoginBox';
import NavBar from './NavBar';

const StyledMainHeader = styled.div`
  display: flex;
  justify-content: space-between;
  background: #4498e7;
  color: #eee;
`;

const TopHeader: React.FC = () => {
  const { i18n } = useTranslation();
  const { role: userRole } = useAuth();

  // Get current language from i18n (defaults to 'fi' if not set)
  const currentLanguage = (i18n.language as UILanguage) || UILanguage.Fi;

  const handleLanguageChange = (lang: UILanguage) => {
    i18n.changeLanguage(lang);
  };

  return (
    <>
      <NavBar userRole={userRole} />
      <StyledMainHeader>
        <NotificationsContainer />
        <Languages currentLanguage={currentLanguage} onLanguageChanged={handleLanguageChange} />
        <LoginBox />
      </StyledMainHeader>
    </>
  );
};

export default TopHeader;
